import { useEffect } from 'react';
import { useUser } from '@descope/react-sdk';
import { analyticsService } from 'services/analyticsService';

/**
 * Component that identifies users in Mixpanel when authenticated
 */
const MixpanelIdentifier: React.FC = () => {
  const { user, isUserLoading } = useUser();

  useEffect(() => {
    if (!isUserLoading && user) {
      // Identify user in Mixpanel
      analyticsService.identify(user.userId, {
        email: user.email,
        name: user.name,
        givenName: user.givenName,
        familyName: user.familyName,
        verifiedEmail: user.verifiedEmail,
        loginIds: user.loginIds,
      });

      console.log('Mixpanel: User identified', user.userId);
    }
  }, [user, isUserLoading]);

  return null; 
};

export default MixpanelIdentifier;
